import { PrimaryButton, Reveal } from "@/components/ui-bits";
import { ServiceTag, ImageFrame } from "@/pages/services/bits";

const BLOCKS = [
  { title: "INSIDE DELIVERY", desc: "Delivery beyond exterior entrance when required." },
  { title: "TWO-PERSON TEAM", desc: "Additional personnel for shipments requiring two-person handling." },
  { title: "RESIDENTIAL DELIVERY", desc: "Transportation and delivery support for residential destinations." },
  { title: "APPOINTMENT DELIVERY", desc: "Delivery coordinated around scheduled appointments." },
  { title: "UNPACKING / UNCRATING", desc: "Assistance with unpacking or uncrating shipments when required." },
  { title: "DEBRIS REMOVAL", desc: "Removal of packaging or delivery-related debris where included in service." },
];

const ServiceSpecialized = () => {
  return (
    <section id="specialized" data-testid="service-specialized" aria-labelledby="specialized-heading" className="scroll-mt-24 bg-[#f7f8f9] py-16 sm:py-20 lg:py-24">
      <div className="container-30">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <ServiceTag number="04" label="Delivery Support" />
            <h2 id="specialized-heading" data-testid="specialized-headline" className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl">
              SPECIALIZED & WHITE-GLOVE DELIVERY
            </h2>
            <p className="mt-3 font-display text-lg font-semibold text-[#191c1e]/80">
              More than transportation. Complete delivery support.
            </p>
            <p className="mt-5 text-base leading-relaxed text-[#5f666d]">
              Some shipments require more than curbside transportation. 30 NORTH provides specialized delivery support for
              shipments that require additional handling, coordination and care.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <ImageFrame
              src="/assets/specialized-delivery-3.webp"
              alt="Two 30 NORTH delivery personnel offloading a blanket-wrapped pallet with a pallet jack from a straight truck liftgate in downtown Toronto"
              testid="specialized-image"
              caption={<>SPECIALIZED DELIVERY <span className="ml-2 text-[#ff6a00]">WHITE-GLOVE SUPPORT</span></>}
            />
          </Reveal>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="specialized-blocks">
          {BLOCKS.map((block, i) => (
            <Reveal key={block.title} delay={i * 0.05} className="h-full">
              <div
                data-testid={`specialized-block-${i + 1}`}
                className="flex h-full flex-col border border-[#e5e7eb] bg-white p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#ff6a00] hover:shadow-[0_14px_28px_-18px_rgba(25,28,30,0.4)]"
              >
                <span className="block h-1.5 w-6 bg-[#ff6a00]" aria-hidden="true" />
                <h3 className="mt-4 font-display text-sm font-bold tracking-[0.1em] text-[#191c1e]">{block.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#5f666d]">{block.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-10">
          <PrimaryButton to="/request-a-quote" testid="specialized-cta">
            PLAN A SPECIALIZED DELIVERY
          </PrimaryButton>
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceSpecialized;
